<script>
  import { onMount } from 'svelte'
  import { Link, navigate } from 'svelte-routing'
  import ContactButtonAtom from '~/Components/Atoms/ContactButton'
  import store from '~/Library/store'

  let isOnMobile = false
  let isShowingMenu = true

  onMount(() => {
    const mediaListener = window.matchMedia('(max-width: 576px)')
    if (mediaListener.matches) {
      isOnMobile = true
    }
  })

  function logout(){
    store.reset()
    navigate('/login', {replace: true})
  }

  function openMobileMenu(){
    store.setAttribute('show_mobile_menu', true)
  }
</script>


<div class="header">

  <h3 class="heading">

    <Link to="/">Next4Me<span class="accent">.</span></Link>

  </h3>

  {#if isOnMobile}

    <div class="header__menu">

      <svg width="30" on:click={openMobileMenu} height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 7H14" stroke="#233348" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 23H23" stroke="#233348" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 15H23" stroke="#233348" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

    </div>

  {:else}

    <nav class="nav__header">

      <Link to="/for-you">For you</Link>

      <Link to="/for-your-career">Your career</Link>

      <Link to="/mentors">Mentors</Link>

      <ContactButtonAtom />

      {#if $store.user}

        <img src="static/icons/logout.svg" on:click={logout} class="nav__logout" alt="">

      {/if}

    </nav>

  {/if}

</div>

<style lang="scss">
  .header {

    display: flex;
    align-items: center;
    padding: 2.625rem 0;
    z-index: 50;

    nav {

      display: flex;
      align-items: center;
      margin-left: auto;

      :global(.nav__logout) {
        margin: 0 1.5rem;
        cursor: pointer;
      }

      :global(a), button {
        margin: 0 1.875rem;
      }

    }

    &__menu {
      justify-self: flex-end;
      margin-top: 0.75rem;
    }

    @media only screen and (max-width: 576px) {

      padding: 0.5rem 0;
      justify-content: space-between;

    }

  }
  :global(nav.nav__header a) {

    display: inline-block;
    position: relative;
    padding-bottom: 0.25rem;

    &[aria-current], &:hover {
      font-weight: medium;
      color: var(--heading-colour);
    }

    &::before {
      content: "";
      position: absolute;
      left: 30%;
      bottom: 0;
      height: 2px;
      width: 0;
      border-bottom: 2px solid var(--heading-colour);
      -webkit-transition: width .25s;
      transition: width .25s;
    }

    &:hover::before, &[aria-current]::before {
      width: 70%;
    }

  }

</style>
